///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.humana = abcsetup.humana || {};
abcsetup.humana.edit = abcsetup.humana.edit || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.humana.edit = {
    init: function () {
        abcsetup.setTitle('Consumer RFP :: Review Event');

        // Reject button clicked
        $('#reject-btn').on('click', function () {
            var _this = $(this);

            abcsetup.alerts.prompt('Rejection Reason', 'Please specify why this consumer RFP is being rejected', function (resp) {
                if (resp[0] == true) {
                    abcsetup.humana.edit.rejectEvent(resp[1]);
                }
            }, true, true);

            return false;
        });

    },

    /**
     *
     */
     rejectEvent: function (reason) {
        var reject_reason = $("<input type='hidden' name='reject_reason' />").val(reason);
        $('#reject-btn').after(reject_reason);
        $('#reject-btn').off('click').attr('type', 'submit').trigger('click');
    },
}
